import { useNotificationSettingsQuery } from '@/src/features/notification/services/useNotificationSettingsQuery'
import { storage } from '@/src/general/utilities/storage'
import { STORAGE_KEYS } from '@/src/general/utilities/storage/MMKVStorage'

export const useWatchman = () => {
  const notifSettings = useNotificationSettingsQuery()

  const executeBecomeLater = () => {
    const askBecomeWatchmanPeriod = getHistoryRefusedBecomeWatchman()
    const { amount = 0 } = typeof askBecomeWatchmanPeriod === 'object' ? askBecomeWatchmanPeriod : {}

    storage.setItem(
      STORAGE_KEYS.ASK_BECOME_WATCHMAN_PERIOD,
      JSON.stringify({
        amount: amount + 1,
        lastRequestDateMs: Date.now(),
      }),
    )
  }

  const getHistoryRefusedBecomeWatchman = (): { lastRequestDateMs: number; amount: number } => {
    return JSON.parse(storage.getItem(STORAGE_KEYS.ASK_BECOME_WATCHMAN_PERIOD) || '{}')
  }

  const isWatchman = notifSettings.data?.on_intention_watchman?.email || notifSettings.data?.on_intention_watchman?.push

  return { executeBecomeLater, getHistoryRefusedBecomeWatchman, isWatchman }
}
